export const DeleteIcon = ({ color = "#EA4335", size = 17, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="17" height="17" rx="3" fill={color} />
        <path
            d="M13.1873 4.75668L12.2431 3.8125L8.49991 7.55573L4.75668 3.8125L3.8125 4.75668L7.55573 8.49991L3.8125 12.2431L4.75668 13.1873L8.49991 9.44409L12.2431 13.1873L13.1873 12.2431L9.44409 8.49991L13.1873 4.75668Z"
            fill="white"
        />
    </svg>
);
